/**
 * hooks/accounts/useMomoAccountForm.ts
 *
 * Form hook for adding a mobile money account.
 * Registered in formHooks as "add_momo_account".
 */

import { COMPONENT, SELECT, TEXT } from "../../constants/constants";
import { API_USER_MOMO_ACCOUNTS } from "../../constants/apis";
import { TSet } from "../common/useSet";
import { reloadData } from "../../components/lists/ListHandler";
import { InfoBox } from "../../components/elements/Elements";
import { showConfetti } from "../../components/elements/ConfettiView";
import { addSelectOption } from "../../utils/helpers";

export const useMomoAccountForm = ({ form }: any) => {
  const fields = [
    {
      type: COMPONENT,
      component: (
        <div className="textCenter p5">
          <div className="font16 bold textDark">Add MoMo Account</div>
          <div className="font12 grey mt5">
            Your mobile money number for deposits and withdrawals
          </div>
        </div>
      ),
    },
    {
      field: "provider",
      label: "Provider",
      type: SELECT,
      required: true,
      options: [
        { id: "mtn_momo", name: "MTN Mobile Money" },
        { id: "airtel_money", name: "Airtel Money" },
      ],
    },
    {
      field: "phone_number",
      label: "Phone Number",
      type: TEXT,
      required: true,
      props: {
        placeholder: "+256700123456",
        helperText: "Include country code (+256)",
      },
    },
    {
      field: "account_name",
      label: "Registered Name",
      type: TEXT,
      required: true,
      props: {
        placeholder: "Name registered on the MoMo account",
      },
    },
    {
      type: COMPONENT,
      component: (
        <InfoBox>
          Ensure the phone number and name match your MoMo registration.
          Mismatches may cause withdrawal delays.
        </InfoBox>
      ),
    },
  ];

  const onSubmit = ({ payload }: any): TSet => {
    return {
      api: API_USER_MOMO_ACCOUNTS,
      params: payload,
      successMessage: {
        message: "MoMo account added successfully!",
        duration: 5,
      },
      onSuccess: () => {
        reloadData("momo_accounts");
        showConfetti();
      },
    };
  };

  const allowSubmit =
    !!form?.provider &&
    !!form?.phone_number &&
    !!form?.account_name;

  return {
    fields,
    onSubmit,
    title: "Add MoMo Account",
    submitText: "Save Account",
    allowSubmit,
  };
};